import { useAppSelector } from "hooks/redux"
import type { FilterScope } from "helpers/filter-scope"
import { useDashboardId } from "../context/dashboard-id"
import { selectEffectiveFilterScope } from "../store/selectors/select-effective-filter-scope"

export function useEffectiveFilterScope(): FilterScope {
  const dashboardId = useDashboardId()
  return useAppSelector((state) => selectEffectiveFilterScope(state, dashboardId))
}
